export default __webpack_public_path__ + "static/media/MainDemo.b9c48e88.gif";